import React from "react";
import { Icon, TopBar, VisuallyHidden } from "@shopify/polaris";
import { QuestionMarkMajor } from "@shopify/polaris-icons";
import { useSearch } from "@usereactify/search";
import { SearchInput, SearchResults } from "~/components/search";
import { useAppContext } from "~/providers/app";

export type HeaderProps = {
  toggleNavigation: () => void;
  isHelpMenuOpen: boolean;
  toggleHelpMenu: () => void;
  isUserMenuOpen: boolean;
  toggleUserMenu: () => void;
};

export function Header({
  toggleNavigation,
  isHelpMenuOpen,
  toggleHelpMenu,
  isUserMenuOpen,
  toggleUserMenu,
}: HeaderProps) {
  const { searchTerm, showInstantSearchResults } = useSearch();

  return (
    <TopBar
      showNavigationToggle
      onNavigationToggle={toggleNavigation}
      searchField={<SearchInput />}
      searchResults={<SearchResults />}
      searchResultsVisible={!!searchTerm && showInstantSearchResults}
      secondaryMenu={<SecondaryMenu isHelpMenuOpen={isHelpMenuOpen} toggleHelpMenu={toggleHelpMenu} />}
      userMenu={<UserMenu isUserMenuOpen={isUserMenuOpen} toggleUserMenu={toggleUserMenu} />}
    />
  );
}

export type SecondaryMenuProps = {
  isHelpMenuOpen: boolean;
  toggleHelpMenu: () => void;
};

function SecondaryMenu({ isHelpMenuOpen, toggleHelpMenu }: SecondaryMenuProps) {
  return (
    <TopBar.Menu
      activatorContent={
        <span>
          <Icon source={QuestionMarkMajor} />
          <VisuallyHidden>Secondary menu</VisuallyHidden>
        </span>
      }
      open={isHelpMenuOpen}
      onOpen={toggleHelpMenu}
      onClose={toggleHelpMenu}
      actions={[
        {
          items: [
            { content: "User Guide", url: "https://search.guides.reactify.com.au", external: true },
            { content: "Documentation", url: "https://search.docs.reactify.com.au", external: true },
          ],
        },
      ]}
    />
  );
}

export type UserMenuProps = {
  isUserMenuOpen: boolean;
  toggleUserMenu: () => void;
};

function UserMenu({ isUserMenuOpen, toggleUserMenu }: UserMenuProps) {
  const { index, shop, returnUrl, refreshConfig, setShowModalConfig, setShowModalIndices } = useAppContext();
  return (
    <TopBar.UserMenu
      actions={[
        {
          items: [
            { content: "Refresh config", onAction: () => refreshConfig() },
            { content: "Edit config", onAction: () => setShowModalConfig(true) },
            { content: "Change index", onAction: () => setShowModalIndices(true) },
          ],
        },
        {
          items: [{ content: "Back to Shopify", url: returnUrl }],
        },
      ]}
      detail={index}
      initials={shop.substring(0, 2).toUpperCase()}
      name={shop.split(".")[0].toUpperCase()}
      open={isUserMenuOpen}
      onToggle={toggleUserMenu}
    />
  );
}
